import * as React from 'react';

import { Container } from '@mui/material';

import WellcomeWidget from './WellcomeWidget';
import { MyExperimentationsWidget } from '../MyExperimentations';
import { CreateExperimentationWidget } from '../SimpleCreateExpriementation'

export default function TeacheHomeView() : JSX.Element
{
    return (
        <Container maxWidth='xl'>
            <WellcomeWidget />
            <CreateExperimentationWidget />
            <MyExperimentationsWidget/>
        </Container>
    )
}